import { FirstImage } from "./FirstImage";
import { SecondImage } from "./SecondImage";
import { ThirdImage } from "./ThirdImage";
import _ from "lodash";
import { config } from "../../constants/config";
import { useEffect, useState } from "react";
import { useArchiveContext } from "../../context/archive.context";
function Image({ images }) {
	const Component = images[_.random(0, images.length - 1)];

	return <Component />;
}
export const NotFound = () => {
	const [show, setShow] = useState(false);

	const { lang } = useArchiveContext();

	const isArabic = lang.toLowerCase().includes("ar");

	useEffect(() => {
		setTimeout(() => {
			setShow(true);
		}, 200);
	}, []);
	return (
		<div
			className="MuiGrid-root main-container root-27 MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-align-content-xs-center MuiGrid-justify-content-xs-center"
			display="flex"
			style={{ marginTop: 50, display: show ? "block" : "none" }}
		>
			<div className="MuiGrid-root contentContainer-28 MuiGrid-item MuiGrid-grid-xs-true">
				<Image images={[FirstImage, SecondImage, ThirdImage]} />

				<p className="MuiTypography-root MuiTypography-h2 MuiTypography-alignCenter title-not-found">
					{isArabic
						? `لم تجد ما تبحث عنه؟ تواصل معنا وأخبرنا كيف يمكننا إضافة مواردنا.`
						: `
				Didn’t find what youre looking for ? Get in touch and let us know how
					we can add to our resources.
				`}
				</p>
				<a
					className="MuiButtonBase-root imageButtonContainer-49 btnclassNameName-29 imageSrc-51 mirroring"
					tabindex="0"
					role="button"
					aria-disabled="false"
					href={config.NOT_FOUND_REDIRECT_LINK}
					style={{ position: "relative" }}
				>
					<div
						className="MuiBox-root MuiBox-root-70 imageTitle-53 imageButton-50"
						style={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							color: "white",
							fontWeight: 600,
						}}
					>
					{isArabic ? "تواصل معنا" : "Get in touch"}	
					</div>
					<svg
						preserveAspectRatio="none"
						// width="200"
						// height="70"
						viewBox="0 0 200 70"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M61.9525 69.9459C74.24 70.3011 170.234 69.0902 178.596 60.7575C186.824 52.5594 197.744 51.9045 199.107 40.7196C200.105 32.529 201.179 34.6459 196.831 27.2603C192.186 19.3717 179.424 9.39796 171.825 5.16051C156.875 -3.17513 29.7065 -0.910978 18.2677 8.35388C-5.26212 27.4119 -5.40305 44.6019 14.0585 61.2769C23.6636 68.4902 49.6642 69.5907 61.9525 69.9459Z"
							fill="#201F57"
						/>
					</svg>
				</a>
			</div>
		</div>
	);
};
